module.exports = import("https://cdn.skypack.dev/tone?min");;